/* Diwali festive effects: toran lights, diya cursor, page-load fireworks.
 * Every visual layer uses pointer-events: none, so clicks always reach the page. */
(function () {
  'use strict';

  if (window.DiwaliFestive) {
    window.DiwaliFestive.init();
    return;
  }

  var SVGNS = 'http://www.w3.org/2000/svg';
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var cleanups = [];

  function rand(min, max) {
    return min + Math.random() * (max - min);
  }

  /* ---------- Shared SVG sprite (marigold, mango leaf) ---------- */

  function petalRing(count, radius, petal, fill, rotation, stroke) {
    var out = '<g fill="' + fill + '"' + (stroke ? ' stroke="' + stroke + '" stroke-width=".35"' : '') + '>';
    for (var i = 0; i < count; i++) {
      var a = rotation + (i * Math.PI * 2) / count;
      out += '<circle cx="' + (radius * Math.cos(a)).toFixed(2) + '" cy="' + (radius * Math.sin(a)).toFixed(2) + '" r="' + petal + '"/>';
    }
    return out + '</g>';
  }

  function ensureSprite() {
    if (document.getElementById('dw-sprite')) return;
    var marigold =
      petalRing(16, 7, 2.7, '#d9620b', 0, '#b44d05') +
      petalRing(12, 5, 2.5, '#ef8410', 0.2) +
      petalRing(9, 3, 2.2, '#f9a51d', 0.1) +
      petalRing(6, 1.4, 1.7, '#ffc23b', 0) +
      '<circle r="1.1" fill="#e07a0c"/>';
    var wrap = document.createElement('div');
    wrap.innerHTML =
      '<svg id="dw-sprite" xmlns="' + SVGNS + '" width="0" height="0" style="position:absolute;width:0;height:0;overflow:hidden" aria-hidden="true">' +
      '<symbol id="dw-marigold" viewBox="-10 -10 20 20">' + marigold + '</symbol>' +
      '<symbol id="dw-leaf" viewBox="-5 0 10 18">' +
      '<path d="M0 0C4.5 4 4.5 12 0 18C-4.5 12-4.5 4 0 0Z" fill="#3d7a2b"/>' +
      '<path d="M0 1V17" stroke="#2b5a1d" stroke-width=".6"/>' +
      '</symbol>' +
      '</svg>';
    document.body.appendChild(wrap.firstChild);
  }

  /* ---------- 1 + 4. Toran with blinking lights and marigolds ---------- */

  var BULB_COLORS = [
    [255, 214, 79],
    [255, 140, 36],
    [255, 66, 88],
    [255, 112, 196],
    [118, 226, 104],
    [255, 246, 214]
  ];

  // Header elements the hanging strings must not cover.
  var OBSTACLES =
    '.theme__logo a, .mobile-menu__trigger, .shopping--cart_links > li, .wishlist-hero-header-icon, .st-desktop-searchbox, .st-mobile-searchbox, .large-search .header-search-form, .js-nav .navigation__menulink';

  function buildToran(cfg) {
    // header.theme-header is the row the theme fixes on scroll, so the toran moves with it.
    var wrapper = document.querySelector('header.theme-header');
    if (!wrapper) return null;
    // Menu links sit in the nav below the header row; still keep drops off them.
    var scope = wrapper.closest('.header-section') || wrapper;

    ensureSprite();
    var el = document.createElement('div');
    el.className = 'dw-toran';
    el.setAttribute('aria-hidden', 'true');
    wrapper.appendChild(el);

    var bulbs = [];
    var lastWidth = 0;
    var timer = 0;

    function obstacleLimits() {
      var base = wrapper.getBoundingClientRect();
      var list = [];
      scope.querySelectorAll(OBSTACLES).forEach(function (node) {
        var r = node.getBoundingClientRect();
        if (r.width && r.height) {
          list.push({ left: r.left - base.left, right: r.right - base.left, top: r.top - base.top });
        }
      });
      return list;
    }

    function spaceBelow(x, halfWidth, obstacles) {
      var limit = Infinity;
      obstacles.forEach(function (o) {
        if (x + halfWidth + 4 > o.left && x - halfWidth - 4 < o.right) limit = Math.min(limit, o.top - 5);
      });
      return limit;
    }

    function render() {
      var w = wrapper.clientWidth;
      if (!w) return;
      lastWidth = w;
      var mobile = w < 750;
      el.style.display = mobile && !cfg.toranMobile ? 'none' : '';

      var topY = 1;
      var sag = mobile ? 11 : 17;
      var hangSize = mobile ? 12 : 16;
      var dropSize = mobile ? 9 : 12;
      var bulbsPerSwag = mobile ? 4 : 6;
      var bulbSize = mobile ? 4 : 5;
      var pad = hangSize * 0.6;
      var swags = Math.max(2, Math.round((w - pad * 2) / (mobile ? 64 : 115)));
      var gap = (w - pad * 2) / swags;
      var obstacles = obstacleLimits();
      var pattern = mobile ? [2, 1] : [3, 2];

      var svg = '';
      var rope = 'M' + pad + ' ' + topY;
      var html = '';
      var maxY = topY + sag + 10;

      for (var i = 0; i < swags; i++) {
        var x0 = pad + i * gap;
        var x1 = x0 + gap;
        var cx = (x0 + x1) / 2;
        var cy = topY + sag * 2;
        rope += ' Q' + cx.toFixed(1) + ' ' + cy + ' ' + x1.toFixed(1) + ' ' + topY;

        for (var j = 1; j <= bulbsPerSwag; j++) {
          var t = j / (bulbsPerSwag + 1);
          var bx = (1 - t) * (1 - t) * x0 + 2 * (1 - t) * t * cx + t * t * x1;
          var by = (1 - t) * (1 - t) * topY + 2 * (1 - t) * t * cy + t * t * topY;
          var c = BULB_COLORS[(i * bulbsPerSwag + j) % BULB_COLORS.length];
          html +=
            '<span class="dw-toran__bulb" style="left:' + bx.toFixed(1) + 'px;top:' + by.toFixed(1) + 'px;--s:' + bulbSize +
            'px;--c:rgb(' + c.join(',') + ');--g:rgba(' + c.join(',') + ',.55)"></span>';
        }
      }

      for (var k = 0; k <= swags; k++) {
        var hx = pad + k * gap;

        if (cfg.toranDrops && k > 0 && k < swags) {
          var wanted = pattern[k % pattern.length];
          var limit = spaceBelow(hx, dropSize / 2 + 2, obstacles);
          var step = dropSize * 0.92;
          var firstY = topY + hangSize * 0.5 + dropSize * 0.45;
          var leafH = dropSize * 1.3;
          var count = 0;
          while (count < wanted && firstY + count * step + dropSize / 2 <= limit) count++;

          if (count) {
            var lastY = firstY + (count - 1) * step;
            var withLeaf = lastY + dropSize / 2 + leafH <= limit;
            var end = withLeaf ? lastY + dropSize / 2 + leafH : lastY;
            svg += '<path d="M' + hx + ' ' + topY + 'V' + end.toFixed(1) + '" stroke="#6b3a17" stroke-width=".9"/>';
            for (var f = 0; f < count; f++) {
              var fy = firstY + f * step;
              svg += '<use href="#dw-marigold" x="' + (hx - dropSize / 2).toFixed(1) + '" y="' + (fy - dropSize / 2).toFixed(1) + '" width="' + dropSize + '" height="' + dropSize + '"/>';
            }
            if (withLeaf) {
              svg += '<use href="#dw-leaf" x="' + (hx - leafH * 0.28).toFixed(1) + '" y="' + (lastY + dropSize * 0.35).toFixed(1) + '" width="' + (leafH * 0.56).toFixed(1) + '" height="' + leafH.toFixed(1) + '"/>';
            }
            maxY = Math.max(maxY, end + 2);
          }
        }

        svg += '<use href="#dw-marigold" x="' + (hx - hangSize / 2).toFixed(1) + '" y="' + (topY - hangSize / 2 + 3).toFixed(1) + '" width="' + hangSize + '" height="' + hangSize + '"/>';
      }

      var ropeSvg = '<path d="' + rope + '" fill="none" stroke="#6b3a17" stroke-width="1.3"/>';
      el.style.height = Math.ceil(maxY) + 'px';
      el.innerHTML =
        '<svg xmlns="' + SVGNS + '" width="' + w + '" height="' + Math.ceil(maxY) + '" viewBox="0 0 ' + w + ' ' + Math.ceil(maxY) + '">' +
        ropeSvg + svg + '</svg>' + html;

      bulbs = Array.prototype.slice.call(el.querySelectorAll('.dw-toran__bulb'));
      bulbs.forEach(function (b) {
        if (reduceMotion || Math.random() < 0.6) b.classList.add('is-on');
      });
    }

    function blink() {
      if (document.hidden || !bulbs.length) return;
      var flips = Math.max(1, Math.round(bulbs.length * 0.07));
      for (var i = 0; i < flips; i++) {
        bulbs[(Math.random() * bulbs.length) | 0].classList.toggle('is-on');
      }
    }

    render();
    if (!reduceMotion) timer = setInterval(blink, 140);

    var resizeTimer = 0;
    function onResize() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        if (wrapper.clientWidth !== lastWidth) render();
      }, 150);
    }
    window.addEventListener('resize', onResize);
    // Logo and fonts can shift the header layout after first paint.
    window.addEventListener('load', render);

    return function () {
      clearInterval(timer);
      clearTimeout(resizeTimer);
      window.removeEventListener('resize', onResize);
      window.removeEventListener('load', render);
      el.remove();
    };
  }

  /* ---------- 2. Diya cursor (desktop / mouse only) ---------- */

  var DIYA_SVG =
    '<svg viewBox="0 0 40 40" xmlns="' + SVGNS + '" aria-hidden="true">' +
    '<defs>' +
    '<radialGradient id="dw-diya-glow"><stop offset="0" stop-color="#ffd27a" stop-opacity=".9"/><stop offset="1" stop-color="#ff9a1f" stop-opacity="0"/></radialGradient>' +
    '<linearGradient id="dw-diya-flame" x1="0" y1="1" x2="0" y2="0"><stop offset="0" stop-color="#ff5a00"/><stop offset=".55" stop-color="#ffa200"/><stop offset="1" stop-color="#ffe066"/></linearGradient>' +
    '<linearGradient id="dw-diya-bowl" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#d0672a"/><stop offset="1" stop-color="#7c2d0e"/></linearGradient>' +
    '</defs>' +
    '<circle class="dw-cursor__glow" cx="20" cy="15" r="11" fill="url(#dw-diya-glow)"/>' +
    '<g class="dw-cursor__flame">' +
    '<path d="M20 2C23.5 8 26 11.5 26 15.5C26 19.3 23.3 22 20 22C16.7 22 14 19.3 14 15.5C14 11.5 16.5 8 20 2Z" fill="url(#dw-diya-flame)"/>' +
    '<path d="M20 10C21.6 13 22.6 14.8 22.6 16.8C22.6 18.6 21.4 20 20 20C18.6 20 17.4 18.6 17.4 16.8C17.4 14.8 18.4 13 20 10Z" fill="#fff6c9"/>' +
    '</g>' +
    '<path d="M3 24.5C9 23 31 23 37 24.5C36 31.5 29 36.5 20 36.5C11 36.5 4 31.5 3 24.5Z" fill="url(#dw-diya-bowl)"/>' +
    '<ellipse cx="20" cy="24.3" rx="17" ry="2.4" fill="#8f3510"/>' +
    '<ellipse cx="20" cy="24" rx="13" ry="1.4" fill="#f3b33d" opacity=".9"/>' +
    '<g fill="#ffd36b"><circle cx="11" cy="29.5" r="1"/><circle cx="15.5" cy="31.5" r="1"/><circle cx="20" cy="32.2" r="1"/><circle cx="24.5" cy="31.5" r="1"/><circle cx="29" cy="29.5" r="1"/></g>' +
    '</svg>';

  var CLICKABLE = 'a, button, [role="button"], label, summary, select, input[type="submit"], input[type="button"], input[type="checkbox"], input[type="radio"], .swatch-input__label';
  var NATIVE = 'input:not([type="button"]):not([type="submit"]):not([type="checkbox"]):not([type="radio"]):not([type="range"]):not([type="color"]), textarea, [contenteditable="true"], select';

  function buildCursor() {
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return null;

    var cursor = document.createElement('div');
    cursor.className = 'dw-cursor';
    cursor.setAttribute('aria-hidden', 'true');
    cursor.innerHTML = DIYA_SVG;
    document.body.appendChild(cursor);
    document.documentElement.classList.add('dw-cursor-active');

    var x = -100;
    var y = -100;
    var frame = 0;

    // The flame tip (18px, 2px inside the 36px box) is the click point.
    function paint() {
      frame = 0;
      cursor.style.transform = 'translate3d(' + (x - 18) + 'px,' + (y - 2) + 'px,0)';
    }

    function onMove(e) {
      x = e.clientX;
      y = e.clientY;
      cursor.classList.add('is-visible');
      var target = e.target && e.target.closest ? e.target : null;
      cursor.classList.toggle('is-native', !!(target && target.closest(NATIVE)));
      cursor.classList.toggle('is-link', !!(target && target.closest(CLICKABLE)));
      if (!frame) frame = requestAnimationFrame(paint);
    }

    function onOut(e) {
      // Leaving the window or moving into an iframe (payment widgets etc.).
      if (!e.relatedTarget || e.relatedTarget.tagName === 'IFRAME') cursor.classList.remove('is-visible');
    }

    function onDown() {
      cursor.classList.add('is-pressed');
    }

    function onUp() {
      cursor.classList.remove('is-pressed');
    }

    document.addEventListener('mousemove', onMove, { passive: true });
    document.addEventListener('mouseout', onOut, { passive: true });
    document.addEventListener('mousedown', onDown, { passive: true });
    document.addEventListener('mouseup', onUp, { passive: true });

    return function () {
      cancelAnimationFrame(frame);
      document.removeEventListener('mousemove', onMove);
      document.removeEventListener('mouseout', onOut);
      document.removeEventListener('mousedown', onDown);
      document.removeEventListener('mouseup', onUp);
      document.documentElement.classList.remove('dw-cursor-active');
      cursor.remove();
    };
  }

  /* ---------- 3. Page-load fireworks ---------- */

  var SPARK_COLORS = [
    [232, 160, 0],
    [255, 106, 0],
    [232, 32, 58],
    [214, 36, 159],
    [31, 163, 74],
    [47, 107, 255],
    [148, 52, 220]
  ];

  function runFireworks(cfg) {
    var canvas = document.createElement('canvas');
    var ctx = canvas.getContext && canvas.getContext('2d');
    if (!ctx) return null;
    canvas.className = 'dw-fireworks';
    canvas.setAttribute('aria-hidden', 'true');
    document.body.appendChild(canvas);

    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var W = 0;
    var H = 0;
    var scale = 1;
    var mobile = false;

    function resize() {
      W = window.innerWidth;
      H = window.innerHeight;
      mobile = W < 750;
      canvas.width = Math.round(W * dpr);
      canvas.height = Math.round(H * dpr);
      canvas.style.width = W + 'px';
      canvas.style.height = H + 'px';
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      scale = Math.max(0.55, Math.min(1.15, Math.min(W, H) / 750));
    }
    resize();
    window.addEventListener('resize', resize);

    var rockets = [];
    var parts = [];
    var timers = [];
    var pending = cfg.rockets;
    var frame = 0;
    var last = 0;

    function pick(list) {
      return list[(Math.random() * list.length) | 0];
    }

    function launch() {
      pending--;
      var sx = W / 2 + rand(-8, 8);
      var sy = H + 6;
      rockets.push({
        sx: sx,
        sy: sy,
        tx: W * rand(0.12, 0.88),
        ty: H * rand(0.1, 0.45),
        x: sx,
        y: sy,
        t: 0,
        dur: rand(0.9, 1.35),
        trail: []
      });
      start();
    }

    function spark(x, y, angle, speed, color, opts) {
      var life = opts.life * rand(0.8, 1.2);
      parts.push({
        x: x,
        y: y,
        vx: Math.cos(angle) * speed,
        vy: Math.sin(angle) * speed,
        life: life,
        max: life,
        c: color,
        w: opts.width,
        drag: opts.drag,
        g: opts.gravity,
        twinkle: opts.twinkle
      });
    }

    function explode(x, y) {
      var n = mobile ? 60 : 95;
      var base = rand(190, 270) * scale;
      var type = pick(['peony', 'peony', 'ring', 'willow', 'duo', 'crackle']);
      var a = pick(SPARK_COLORS);
      var b = pick(SPARK_COLORS);
      var opts = { life: rand(1.1, 1.5), width: 2.2, drag: 0.955, gravity: 90, twinkle: false };

      if (type === 'willow') {
        a = b = [222, 140, 10];
        opts = { life: 2.1, width: 1.5, drag: 0.972, gravity: 70, twinkle: false };
      } else if (type === 'crackle') {
        opts.twinkle = true;
        b = [255, 184, 0];
      }

      for (var i = 0; i < n; i++) {
        var angle = (i / n) * Math.PI * 2 + rand(-0.05, 0.05);
        var speed = type === 'ring' ? base * rand(0.92, 1) : base * rand(0.35, 1);
        var color = type === 'duo' || type === 'crackle' ? (i % 2 ? a : b) : a;
        spark(x, y, angle, speed, color, opts);
      }
      parts.push({ flash: true, x: x, y: y, life: 0.18, max: 0.18, r: 46 * scale, c: a });
    }

    function update(dt) {
      for (var i = rockets.length - 1; i >= 0; i--) {
        var r = rockets[i];
        r.t += dt;
        var k = Math.min(1, r.t / r.dur);
        var e = 1 - Math.pow(1 - k, 2.2);
        r.x = r.sx + (r.tx - r.sx) * e + Math.sin(k * 12) * 1.5;
        r.y = r.sy + (r.ty - r.sy) * e;
        r.trail.push(r.x, r.y);
        if (r.trail.length > 24) r.trail.splice(0, 2);
        if (Math.random() < 0.7) {
          spark(r.x, r.y, rand(1.2, 1.94), rand(15, 45), [240, 130, 30], { life: 0.35, width: 1.2, drag: 0.92, gravity: 60, twinkle: false });
        }
        if (k >= 1) {
          explode(r.x, r.y);
          rockets.splice(i, 1);
        }
      }

      for (var j = parts.length - 1; j >= 0; j--) {
        var p = parts[j];
        p.life -= dt;
        if (p.life <= 0) {
          parts.splice(j, 1);
          continue;
        }
        if (p.flash) continue;
        var f = Math.pow(p.drag, dt * 60);
        p.vx *= f;
        p.vy = p.vy * f + p.g * dt;
        p.x += p.vx * dt;
        p.y += p.vy * dt;
      }
    }

    function draw() {
      ctx.globalCompositeOperation = 'source-over';
      ctx.clearRect(0, 0, W, H);
            ctx.lineCap = 'round';

      rockets.forEach(function (r) {
        var t = r.trail;
        for (var i = 2; i < t.length; i += 2) {
          ctx.strokeStyle = 'rgba(235,140,40,' + ((i / t.length) * 0.9).toFixed(2) + ')';
          ctx.lineWidth = 2.2;
          ctx.beginPath();
          ctx.moveTo(t[i - 2], t[i - 1]);
          ctx.lineTo(t[i], t[i + 1]);
          ctx.stroke();
        }
        ctx.fillStyle = '#ffb000';
        ctx.beginPath();
        ctx.arc(r.x, r.y, 2.4, 0, Math.PI * 2);
        ctx.fill();
      });

      parts.forEach(function (p) {
        var alpha = p.life / p.max;
        if (p.flash) {
          var g = ctx.createRadialGradient(p.x, p.y, 0, p.x, p.y, p.r);
          g.addColorStop(0, 'rgba(' + p.c.join(',') + ',' + (alpha * 0.55).toFixed(2) + ')');
          g.addColorStop(1, 'rgba(' + p.c.join(',') + ',0)');
          ctx.fillStyle = g;
          ctx.beginPath();
          ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
          ctx.fill();
          return;
        }
        if (p.twinkle && Math.random() < 0.45) alpha *= 0.2;
        ctx.strokeStyle = 'rgba(' + p.c.join(',') + ',' + alpha.toFixed(2) + ')';
        ctx.lineWidth = p.w;
        ctx.beginPath();
        ctx.moveTo(p.x - p.vx * 0.035, p.y - p.vy * 0.035);
        ctx.lineTo(p.x, p.y);
        ctx.stroke();
      });
    }

    function tick(now) {
      var dt = last ? Math.min(0.033, (now - last) / 1000) : 0.016;
      last = now;
      update(dt);
      draw();
      if (!pending && !rockets.length && !parts.length) {
        stop();
        return;
      }
      frame = rockets.length || parts.length ? requestAnimationFrame(tick) : 0;
      if (!frame) last = 0;
    }

    function start() {
      if (!frame) frame = requestAnimationFrame(tick);
    }

    function stop() {
      cancelAnimationFrame(frame);
      frame = 0;
      timers.forEach(clearTimeout);
      window.removeEventListener('resize', resize);
      canvas.remove();
    }

    var delay = 350;
    for (var i = 0; i < cfg.rockets; i++) {
      timers.push(setTimeout(launch, delay));
      delay += rand(380, 900);
    }

    return stop;
  }

  function shouldFire(cfg, designMode) {
    if (reduceMotion) return false;
    if (cfg.fireworksPages === 'home' && cfg.template !== 'index') return false;
    if (cfg.fireworksFrequency === 'session' && !designMode) {
      try {
        if (sessionStorage.getItem('dw-fireworks-shown')) return false;
        sessionStorage.setItem('dw-fireworks-shown', '1');
      } catch (e) {
        /* storage blocked: show anyway */
      }
    }
    return true;
  }

  /* ---------- Cart success: a small burst from the originating button ---------- */

  function buildCartFeedback() {
    var active = null;
    var timer = 0;
    var status = document.createElement('span');
    status.className = 'visually-hidden dw-cart-status';
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    status.setAttribute('aria-atomic', 'true');
    document.body.appendChild(status);

    function clear() {
      clearTimeout(timer);
      if (active) active.remove();
      active = null;
      status.textContent = '';
    }

    var stopBlast = null;
    var popTimer = 0;

    function onAdded(event) {
      var button = event.detail && event.detail.button;
      if (!button || !button.isConnected) return;
      var rect = button.getBoundingClientRect();
      if (!rect.width || !rect.height) return;
      clear();
      if (stopBlast) stopBlast();
      ensureSprite();

      var x = rect.left + rect.width / 2;
      var y = rect.top + rect.height / 2;
      var layer = document.createElement('div');
      layer.className = 'dw-cart-feedback';
      layer.setAttribute('aria-hidden', 'true');
      layer.style.left = x + 'px';
      layer.style.top = y + 'px';

      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        stopBlast = cartBlast(rect);
        clearTimeout(popTimer);
        button.classList.remove('dw-atc-pop');
        void button.offsetWidth;
        button.classList.add('dw-atc-pop');
        popTimer = setTimeout(function () {
          button.classList.remove('dw-atc-pop');
        }, 450);
      }

      var message = document.createElement('span');
      message.className = 'dw-cart-feedback__message';
      message.innerHTML =
        '<svg class="dw-cart-feedback__icon" viewBox="0 0 20 20" aria-hidden="true"><use href="#dw-marigold" width="20" height="20"/></svg>' +
        '<span>Added to cart</span>';
      // Clamp the pill to the viewport, including narrow mobile screens.
      message.style.left = (Math.max(100, Math.min(window.innerWidth - 100, x)) - x) + 'px';
      message.style.top = (rect.top >= 60 ? rect.top - y - 48 : rect.bottom - y + 12) + 'px';
      layer.appendChild(message);
      document.body.appendChild(layer);
      active = layer;
      status.textContent = 'Added to cart';
      timer = setTimeout(function () {
        message.classList.add('is-leaving');
        timer = setTimeout(clear, 300);
      }, 2700);
    }

    document.addEventListener('dw:cart-added', onAdded);
    return function () {
      document.removeEventListener('dw:cart-added', onAdded);
      clearTimeout(popTimer);
      if (stopBlast) stopBlast();
      clear();
      status.remove();
    };
  }

  // Cracker blast around the button: sparks leave from every edge so wide
  // buttons still show the burst, in colours that read on cream and terracotta.
  var BLAST_COLORS = [
    [255, 176, 0],
    [255, 122, 0],
    [232, 160, 0],
    [214, 36, 159],
    [31, 163, 74],
    [255, 214, 79]
  ];

  function cartBlast(rect) {
    var canvas = document.createElement('canvas');
    var ctx = canvas.getContext && canvas.getContext('2d');
    if (!ctx) return null;
    canvas.className = 'dw-fireworks dw-cart-blast';
    canvas.setAttribute('aria-hidden', 'true');
    document.body.appendChild(canvas);

    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var W = window.innerWidth;
    var H = window.innerHeight;
    canvas.width = Math.round(W * dpr);
    canvas.height = Math.round(H * dpr);
    canvas.style.width = W + 'px';
    canvas.style.height = H + 'px';
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);

    var cx = rect.left + rect.width / 2;
    var cy = rect.top + rect.height / 2;
    var small = W < 750;
    var parts = [];
    var frame = 0;
    var last = 0;
    var elapsed = 0;
    var RING_TIME = 0.45;

    function pick(list) {
      return list[(Math.random() * list.length) | 0];
    }

    function add(x, y, angle, speed, opts) {
      var life = opts.life * rand(0.8, 1.2);
      parts.push({
        x: x,
        y: y,
        vx: Math.cos(angle) * speed,
        vy: Math.sin(angle) * speed,
        life: life,
        max: life,
        c: opts.color || pick(BLAST_COLORS),
        w: opts.width,
        drag: opts.drag,
        g: opts.gravity,
        glitter: !!opts.glitter
      });
    }

    // Main burst from the centre of the button.
    var core = small ? 46 : 64;
    for (var i = 0; i < core; i++) {
      add(cx, cy, (i / core) * Math.PI * 2 + rand(-0.08, 0.08), rand(300, 520), { life: 0.9, width: 2.8, drag: 0.93, gravity: 260 });
    }

    // Edge sparks along the top, bottom and sides, flying outward.
    var edge = small ? 28 : 44;
    for (var e = 0; e < edge; e++) {
      var t = Math.random();
      var side = e % 4;
      var ex, ey, ang;
      if (side === 0) {
        ex = rect.left + t * rect.width; ey = rect.top; ang = -Math.PI / 2;
      } else if (side === 1) {
        ex = rect.left + t * rect.width; ey = rect.bottom; ang = Math.PI / 2;
      } else if (side === 2) {
        ex = rect.left; ey = rect.top + t * rect.height; ang = Math.PI;
      } else {
        ex = rect.right; ey = rect.top + t * rect.height; ang = 0;
      }
      add(ex, ey, ang + rand(-0.7, 0.7), rand(160, 320), { life: 0.7, width: 2.2, drag: 0.92, gravity: 220 });
    }

    // Lingering glitter that drifts down.
    var glitter = small ? 18 : 28;
    for (var g = 0; g < glitter; g++) {
      add(cx + rand(-rect.width / 2, rect.width / 2), cy, rand(-Math.PI, 0), rand(60, 200), {
        life: 1.3,
        width: 2,
        drag: 0.95,
        gravity: 120,
        glitter: true,
        color: [255, 190, 30]
      });
    }

    function draw(dt) {
      elapsed += dt;
      ctx.clearRect(0, 0, W, H);
      ctx.lineCap = 'round';

      // Flash and shock ring hugging the button shape.
      if (elapsed < RING_TIME) {
        var k = elapsed / RING_TIME;
        var grow = 6 + k * 46;
        if (elapsed < 0.14) {
          var flash = ctx.createRadialGradient(cx, cy, 0, cx, cy, Math.max(rect.width, rect.height) * 0.7);
          flash.addColorStop(0, 'rgba(255,220,120,' + (0.55 * (1 - elapsed / 0.14)).toFixed(2) + ')');
          flash.addColorStop(1, 'rgba(255,170,40,0)');
          ctx.fillStyle = flash;
          ctx.fillRect(rect.left - 60, rect.top - 60, rect.width + 120, rect.height + 120);
        }
        ctx.strokeStyle = 'rgba(232,150,0,' + (0.85 * (1 - k)).toFixed(2) + ')';
        ctx.lineWidth = 3 * (1 - k) + 0.5;
        ctx.beginPath();
        ctx.ellipse(cx, cy, rect.width / 2 + grow, rect.height / 2 + grow, 0, 0, Math.PI * 2);
        ctx.stroke();
      }

      for (var j = parts.length - 1; j >= 0; j--) {
        var p = parts[j];
        p.life -= dt;
        if (p.life <= 0) {
          parts.splice(j, 1);
          continue;
        }
        var f = Math.pow(p.drag, dt * 60);
        p.vx *= f;
        p.vy = p.vy * f + p.g * dt;
        p.x += p.vx * dt;
        p.y += p.vy * dt;

        var alpha = Math.min(1, (p.life / p.max) * 1.4);
        if (p.glitter) {
          if (Math.random() < 0.4) alpha *= 0.15;
          ctx.fillStyle = 'rgba(' + p.c.join(',') + ',' + alpha.toFixed(2) + ')';
          ctx.beginPath();
          ctx.arc(p.x, p.y, p.w, 0, Math.PI * 2);
          ctx.fill();
          continue;
        }
        ctx.strokeStyle = 'rgba(' + p.c.join(',') + ',' + alpha.toFixed(2) + ')';
        ctx.lineWidth = p.w;
        ctx.beginPath();
        ctx.moveTo(p.x - p.vx * 0.03, p.y - p.vy * 0.03);
        ctx.lineTo(p.x, p.y);
        ctx.stroke();
      }
    }

    function tick(now) {
      var dt = last ? Math.min(0.033, (now - last) / 1000) : 0.016;
      last = now;
      draw(dt);
      if (!parts.length && elapsed >= RING_TIME) {
        stop();
        return;
      }
      frame = requestAnimationFrame(tick);
    }

    function stop() {
      cancelAnimationFrame(frame);
      canvas.remove();
    }

    frame = requestAnimationFrame(tick);
    return stop;
  }

  /* ---------- Lifecycle ---------- */

  function readConfig(root) {
    var d = root.dataset;
    return {
      sectionId: d.sectionId,
      toran: d.toran === 'true',
      toranMobile: d.toranMobile === 'true',
      toranDrops: d.toranDrops === 'true',
      cursor: d.cursor === 'true',
      fireworks: d.fireworks === 'true',
      fireworksPages: d.fireworksPages,
      fireworksFrequency: d.fireworksFrequency,
      rockets: Math.max(1, parseInt(d.rockets, 10) || 5),
      template: d.template
    };
  }

  function destroy() {
    while (cleanups.length) cleanups.pop()();
  }

  function init() {
    destroy();
    var root = document.querySelector('[data-dw-festive]');
    if (!root) return;
    var cfg = readConfig(root);
    var designMode = !!(window.Shopify && window.Shopify.designMode);
    var parts = [buildCartFeedback()];

    if (cfg.toran) parts.push(buildToran(cfg));
    if (cfg.cursor) parts.push(buildCursor());

    if (cfg.fireworks && shouldFire(cfg, designMode)) {
      var fire = function () {
        cleanups.push(runFireworks(cfg) || function () {});
      };
      if (document.hidden) {
        var onVisible = function () {
          if (document.hidden) return;
          document.removeEventListener('visibilitychange', onVisible);
          fire();
        };
        document.addEventListener('visibilitychange', onVisible);
        parts.push(function () {
          document.removeEventListener('visibilitychange', onVisible);
        });
      } else {
        fire();
      }
    }

    parts.forEach(function (fn) {
      if (fn) cleanups.push(fn);
    });
  }

  window.DiwaliFestive = { init: init, destroy: destroy };

  // Theme editor: re-run when this section's settings change.
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('[data-dw-festive]')) init();
  });
  document.addEventListener('shopify:section:unload', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('[data-dw-festive]')) destroy();
  });
  // Header re-render in the editor drops the toran; rebuild it.
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('.header-section')) init();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
